import React from 'react';
import styled from 'styled-components';
import { LogoImage } from '../../styles';
import { Link } from 'react-router-dom';
import { BLOB_TYPES, PAGE_URLS } from '@constants';
import { generateStorageBlobUrl } from '@utils/generateAssetLinks';

const Style = styled.div`
    background-color: #02436D;
    width: 100%;
    position: absolute;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    a {
        color: #fff;
        text-decoration: none;
        padding: 10px;
    }
    button {
        outline: none;
        background-color: none;
    }
    >div {
        display: flex;
        align-items: center;
    }
`;

export const AdminNav = () => {
    return (
        <Style>
            <div>
                <LogoImage
                    view='admin'
                    src={generateStorageBlobUrl(BLOB_TYPES.logo, 'Strategic Consulting')}
                    alt='Strategic Logo' 
                />
                <Link to={PAGE_URLS.ADMIN_UPLOAD}>Upload</Link>
                <Link to={PAGE_URLS.HEALTH_CHECK}>Health Check Status</Link>
            </div>
            <div>
                <Link to={PAGE_URLS.CLIENT_LOGIN}>Logout</Link>
            </div>
        </Style>
    );
};

export default AdminNav;